const src = import.meta.ROLLUP_FILE_URL_i2ywl_YzKp2MjtOEr7ngzA;
export default {
  src,
  srcSet: src + " " + 1332 + "w",
  width: 1332,
  height: 890,
};